import { EXTERNAL_HREF_PATTERN } from "./href";

/**
 * Validates that a redirect URL is a safe same-origin relative path
 * to prevent open redirect attacks.
 */
export const isAllowedRedirectUrl = (url: string): boolean => {
  if (!url.startsWith("/") || EXTERNAL_HREF_PATTERN.test(url)) return false;

  // Decode and re-check to catch encoded bypasses (e.g. %2F%2Fevil.com)
  try {
    if (EXTERNAL_HREF_PATTERN.test(decodeURIComponent(url))) return false;
  } catch {
    // Malformed encoding — reject
    return false;
  }

  return true;
};
